import { jwtInterceptor } from "./auth.service";

export const getWines = async () => {
  try {
    const resp = await jwtInterceptor.get('/wines/');
    return resp.data;
  } catch(err) {
    return [];
  }
}